import { OKRCategories } from './types/OKRCategories';
import { logCoreUsage } from 'owa-analytics';

/**
 * This file is for logging the new BizChat Copilot Chat side pane.
 */
type CopilotChatSidePaneTelemetryEvent =
    | 'CopilotSidePane_BizChatOpened'
    | 'CopilotSidePane_BizChatClosed'
    | 'CopilotSidePane_ExpandCollapseClicked'
    | 'CopilotSidePane_UserResized';

const CopilotChatSidePaneScenario = 'BizChatSidePane';

function getOKRCategoryForEvent(event: CopilotChatSidePaneTelemetryEvent): OKRCategories {
    switch (event) {
        case 'CopilotSidePane_BizChatOpened':
            return OKRCategories.Seen;
        case 'CopilotSidePane_BizChatClosed':
            return OKRCategories.Closed;
        default:
            return OKRCategories.None;
    }
}

function getActionForEvent(event: CopilotChatSidePaneTelemetryEvent): string {
    switch (event) {
        case 'CopilotSidePane_BizChatOpened':
            return 'Seen';
        case 'CopilotSidePane_BizChatClosed':
            return 'Closed';
        default:
            return OKRCategories.None;
    }
}

export function logCopilotChatSidePaneTelemetryEvent(
    event: CopilotChatSidePaneTelemetryEvent,
    customData: {
        [key: string]: any;
    } = {}
): void {
    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logCoreUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    logCoreUsage('AIStandardTelemetry', undefined, {
        CopilotEventName: event,
        Scenario: CopilotChatSidePaneScenario,
        OKRCategory: getOKRCategoryForEvent(event),
        Action: getActionForEvent(event),
        ...customData,
    });
}
